import useGetExaminationSession, { QmsExamSession } from './useGetExaminationSession';

export type { QmsExamSession };
export default useGetExaminationSession;
